import { FRAMEWORK_TITLES } from '@/shared/consts';
import { CreateEnterpriseFrameworkDto } from '@/stores/EnterpriseStore/EnterpriseStore.consts';

export const convertFrameworksToText = (frameworks: CreateEnterpriseFrameworkDto[]) => {
  return frameworks
    .map((framework) =>
      Object.keys(framework)
        .map(
          (key: string) =>
            `${key.charAt(0).toUpperCase() + key.slice(1)}: ${
              key === 'code'
                ? FRAMEWORK_TITLES[framework[key as keyof CreateEnterpriseFrameworkDto] as string]
                : framework[key as keyof CreateEnterpriseFrameworkDto]
            }`
        )
        .join(' - ')
    )
    .join('\n');
};
